import { DocumentRequestBtn } from '@components/buzzkuri/shared/DocumentRequestBtn'
import { getDomain } from '@utils/http'
import React from 'react'

export const DocumentRequest = (): JSX.Element => (
  <div className="flex justify-center">
    <div className="w-[87.5vw] lg:w-[28.8vw] h-[13.3vw] lg:h-[4.7vw]">
      <DocumentRequestBtn
        title="無料で資料請求"
        customDataAttribute={{
          attributeName: 'data-program-feature-button',
          attributeValue: `https://${getDomain}/programs/`,
        }}
        classes="rounded-[11px] lg:rounded-[20px] lg:text-[1.6vw] shadow-30px text-[4.5vw] lg:text-[1.3vw]"
        hasArrow
      />
    </div>
  </div>
)
